import { Activity, PropsWithChildren } from 'react';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import Text from '@ui/text/text/text';
import TooltipPortal from '@ui/tooltip-portal/tooltip-portal';

type Props = PropsWithChildren<{
  title: string;
  tooltipContent?: string;
}>;

const CastCrewSectionHeader = ({ title, tooltipContent, children }: Props) => {
  return (
    <div data-component="CastHeader" className="padding-v-12 flex ai-center jc-space-between">
      <div className="flex ai-center gap-4">
        <Text tag="h5" className="H5" design="GlobalIcoText1">
          {title}
        </Text>
        <Activity mode={tooltipContent ? 'visible' : 'hidden'}>
          <TooltipPortal
            tooltipContent={<Text design="GlobalIcoText1">{tooltipContent}</Text>}
            styles={{ backgroundColor: 'var(--global-cont-4)' }}
          >
            <Icon name={ICONS.INFO_CIRCLE} size={10} color="var(--global-ico-text-3)" />
          </TooltipPortal>
        </Activity>
      </div>

      {children}
    </div>
  );
};

export default CastCrewSectionHeader;
